// extracted by mini-css-extract-plugin
export var active = "Mobile-module--active--6263f";
export var content = "Mobile-module--content--49413";
export var editButton = "Mobile-module--editButton--6f27d";
export var fadeInAnimation = "Mobile-module--fadeInAnimation--0cf60";
export var fontMd = "Mobile-module--fontMd--b0c2f";
export var item = "Mobile-module--item--5bc4a";